import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AuroraHeroSection from './components/AuroraHeroSection';
import AuroraOverviewSection from './components/AuroraOverviewSection';
import AuroraComparisonSection from './components/AuroraComparisonSection';
import AuroraTrustSection from './components/AuroraTrustSection';
import AuroraFeaturesSection from './components/AuroraFeaturesSection';
import AuroraFeesSection from './components/AuroraFeesSection';
import AuroraCTASection from './components/AuroraCTASection';

export default function AuroraCardPage() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main>
        <AuroraHeroSection />
        <AuroraOverviewSection />
        <AuroraComparisonSection />
        <AuroraTrustSection />
        <AuroraFeaturesSection />
        <AuroraFeesSection />
        <AuroraCTASection />
      </main>
      <Footer />
    </div>
  );
}
